export const MOBILE_APP_ONE_LINK =
  'https://sravni.onelink.me/cyn1?pid=sravni.ru&is_retargeting=true&af_channel=display&c=mfo_web2app__calculator&af_reengagement_window=30d&af_adset=origin--raw_default&action={"type": "infoScreen","params": {},"requestParams":{"mappingName":"mfo_promo_landing"},"analyticId":"screenOpenedFromDeeplink"}';

export const FULL_DEAL_MOBILE_APP_LINKS = {
  FROM_MODAL_OFFER: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=13581',
  FROM_REFERAL_VITRINA_PROMO: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=13580',
  FROM_LANDING_PROMO: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=13579',
  FROM_LANDING: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=13316',
  FROM_CALCULATOR_BOTTOM_SHEET: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=219894',
};

export const FULL_DEAL_WEB_TO_WEB_LINKS = {
  FROM_OFFER_MOBILE: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=13581',
  FROM_MODAL_OFFER: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=13326',
  FROM_REFERAL_VITRINA: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=13319',
  FROM_LANDING: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=13320',
  FROM_CALCULATOR_BOTTOM_SHEET: 'https://goto.startracking.ru/api/v1/redirect?offer_id=2443&aff_id=2&landing_id=219895',
};

export const FULL_DEAL_WEB_TO_WEB_SOURCE = {
  FROM_MODAL_OFFER: 'ref_offer_modal_window_500rub_web_to_web',
  FROM_REFERAL_VITRINA: 'header_calculator_web_to_web',
  FROM_LANDING: 'landing_calculator_web_to_web',
  FROM_CALCULATOR_BOTTOM_SHEET: 'tooltip_calculator_web_to_web',
};

export const FULL_DEAL_MOBILE_APP_SOURCE = {
  FROM_MODAL_OFFER: 'ref_offer_modal_window_500rub_web_to_app',
  FROM_REFERAL_VITRINA_PROMO: 'header_calculator_web_to_app',
  FROM_LANDING_PROMO: 'landing_calculator_web_to_app',
  FROM_LANDING: 'header_calculator_web_to_app',
  FROM_CALCULATOR_BOTTOM_SHEET: 'tooltip_calculator_web_to_app',
};

export const getFullDealMobileAppSource = (isLanding: boolean) =>
  isLanding ? FULL_DEAL_MOBILE_APP_SOURCE.FROM_LANDING_PROMO : FULL_DEAL_MOBILE_APP_SOURCE.FROM_REFERAL_VITRINA_PROMO;

export const getFullDealMobileAppLinkPromo = (isLanding: boolean) =>
  isLanding ? FULL_DEAL_MOBILE_APP_LINKS.FROM_LANDING_PROMO : FULL_DEAL_MOBILE_APP_LINKS.FROM_REFERAL_VITRINA_PROMO;

export const getFullDealWebToWebSource = (isLanding: boolean) =>
  isLanding ? FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_LANDING : FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_REFERAL_VITRINA;
export const getFullDealWebToWebLink = (isLanding: boolean) =>
  isLanding ? FULL_DEAL_WEB_TO_WEB_LINKS.FROM_LANDING : FULL_DEAL_WEB_TO_WEB_LINKS.FROM_REFERAL_VITRINA;
